module.exports = __webpack_public_path__ + "static/media/3d-profile.38b5cc6b.png";